import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  Slide,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { useState, forwardRef } from "react";
import axios from "axios";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RSVP = ({ open, close, onSuccess }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [partySize, setPartySize] = useState(1);
  const [mealChoices, setMealChoices] = useState([""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePartySizeChange = (e) => {
    const size = parseInt(e.target.value, 10) || 0;
    setPartySize(size);
    setMealChoices(Array(size).fill(""));
  };

  const handleMealChange = (index, value) => {
    const updated = [...mealChoices];
    updated[index] = value;
    setMealChoices(updated);
  };

  const handleSubmit = async () => {
    const url = "https://qoqm598zcb.execute-api.us-west-1.amazonaws.com/rsvp";
    const payload = { name, email, partySize, mealChoices };
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(url, payload);
      console.log("RSVP submitted:", response.data);
      onSuccess();
    } catch (error) {
      console.error("RSVP submission failed:", error);
      setError("It looks like there was an error. Please try again.")
    }
    setLoading(false);
  };

  const handleClose = () => {
    setName("");
    setEmail("");
    setPartySize(1);
    setMealChoices([""]);
    close();
  };

  const isFormValid =
    name.trim() !== "" &&
    email.trim() !== "" &&
    partySize > 0 &&
    mealChoices.every((choice) => choice.trim() !== "");

  return (
    <Dialog
      open={open}
      onClose={close}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: "18px",
          backgroundColor: "#f2efeb",
        },
      }}
    >
      <DialogTitle style={{ fontFamily: "Montserrat", color: "#810605" }}>
        RSVP Is Closed
      </DialogTitle>
      <DialogContent>
        <Typography>Sorry, you can no longer RSVP.</Typography>
      </DialogContent>
     
    </Dialog>
  );
};

export default RSVP;
